import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLogoutMutation } from "../../services/api";
import { logout, selectUserRoleLevel } from "../../store/slices/authSlice";
import Loading from "../../Components/common/Loading";

export default function Logout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userRoleLevel = useSelector(selectUserRoleLevel);
  const [logoutMutation] = useLogoutMutation();

  useEffect(() => {
    const performLogout = async () => {
      // Determine redirect path based on role level BEFORE logging out
      const isAdmin = userRoleLevel >= 4;
      const redirectPath = isAdmin ? "/admin/login" : "/login";

      try {
        // Call backend logout endpoint (refresh token is in HttpOnly cookie)
        await logoutMutation().unwrap();
      } catch (error) {
        console.error("Logout API call failed:", error);
        // Continue with logout even if API call fails
      } finally {
        // Clear Redux state (this also clears localStorage via persist)
        dispatch(logout());

        // Redirect to appropriate login page
        navigate(redirectPath, { replace: true });
      }
    };

    performLogout();
  }, [navigate, dispatch, userRoleLevel, logoutMutation]);

  return <Loading fullPage={true} />;
}
